import { t } from 'i18next';

export const getErrorMessage = (error, fallbackMessage) => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (error?.response?.data?.status_message) {
    return error.response.data.status_message;
  }
  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.response?.data?.errors) {
    const errors = error.response.data.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      return errors.map((err) => err.message || err).join(', ');
    }
  }

  if (error?.code === 'NETWORK_ERROR' || error?.message?.includes('Network Error')) {
    return t('common:errors.network');
  }

  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
    return t('common:errors.timeout');
  }

  if (error?.response?.status) {
    const status = error.response.status;
    if (status === 401) return t('common:errors.unauthorized');
    if (status === 403) return t('common:errors.forbidden');
    if (status === 404) return t('common:errors.notFound');
    if (status === 500) return t('common:errors.server');
    if (status >= 400 && status < 500) return t('common:errors.invalidRequest');
    if (status >= 500) return t('common:errors.server');
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage || t('common:errors.unexpected');
};
